import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Tooltip, Typography} from 'antd'
import {EyeOutlined, ExclamationCircleFilled} from '@ant-design/icons'
import DetailsFormModal from './DetailsFormModal'
import {withTranslation} from 'react-i18next'
const { Text } = Typography;

@inject('manualOutboundCallStore')
@observer
class SearchResult extends Component {
  state = {
    viewModalVisible: false
  }

  handlePageChange = (page, pageSize) => {
    const {manualOutboundCallStore} = this.props
    manualOutboundCallStore.onChangePageNumAction(page, pageSize)
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handleView = (record) => {
    const {manualOutboundCallStore} = this.props
    manualOutboundCallStore.onGetJobAction({id: record.id}).then(res => {
      this.setState({
        viewModalVisible: true
      })
    })
  }

  handleCancel = () => {
    this.setState({
      viewModalVisible: false
    })
  }

  render() {
    const {manualOutboundCallStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList} = manualOutboundCallStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const columns = [
      // {
      //   title: t(`outboundCall.id`),
      //   dataIndex: 'id',
      //   key: 'id',
      //   ellipsis: true
      // },
      {
        title: t(`outboundCall.groupName`),
        dataIndex: 'marketGroupName',
        key: 'marketGroupName',
        ellipsis: true
      },
      {
        title: t(`outboundCall.visitorPhone`),
        dataIndex: 'visitorPhone',
        key: 'visitorPhone',
        ellipsis: true
      },
      {
        title: t(`outboundCall.callingStatus`),
        dataIndex: 'callStatus',
        key: 'callStatus',
        ellipsis: true,
        render: (text) => (
          statusList.find(item => item?.code === text)?.name || text
        )
      },
      {
        title: t(`outboundCall.syncStatus`),
        dataIndex: 'syncStatus',
        key: 'syncStatus',
        ellipsis: true,
        render: (text) => (
          text===1 ? t(`outboundCall.synced`) : t(`outboundCall.unsynced`) || text
        )
      },
      {
        title: t(`outboundCall.unansweredReason`),
        dataIndex: 'notConnectedReason',
        key: 'notConnectedReason',
        ellipsis: true,
        render: (text) => (
          <Tooltip title={text}>
            <Text type="danger">{text}</Text>
          </Tooltip>
        )
      },
      {
        title: t(`outboundCall.callTime`),
        dataIndex: 'callTime',
        key: 'callTime',
        ellipsis: true,
        width: 170,
      },
      {
        title: <>
          {t(`outboundCall.billingDuration`)}
          <Tooltip title={t(`outboundCall.billingDurationTips`)}>
            <ExclamationCircleFilled />
          </Tooltip>
        </>,
        dataIndex: 'billableDuration',
        key: 'billableDuration',
        ellipsis: true
      },
      {
        title: t(`outboundCall.callDuration`),
        dataIndex: 'duration',
        key: 'duration',
        ellipsis: true
      },
      {
        title: t(`outboundCall.operator`),
        dataIndex: 'createUser',
        key: 'createUser',
        ellipsis: true,
        render: (text) => (
          <Tooltip title={text}>
            <span>{text}</span>
          </Tooltip>
        )
      },
      {
        title: t(`outboundCall.createTime`),
        dataIndex: 'createTime',
        key: 'createTime',
        ellipsis: true,
        width: 170,
      },
      {
        width: 80,
        align: 'center',
        title: t(`general.action`),
        key: 'action',
        render: (text, record) => (
          <Button type="link" onClick={() => this.handleView(record)} icon={<EyeOutlined/>} />
        )
      }
    ]
    
    return (
      <>
        <Table 
          className="searchResult" 
          dataSource={toJS(jobList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName}
          columns={columns}
          scroll={{x: '100%'}}
        />
        {this.state.viewModalVisible ? (
          <DetailsFormModal
            addModalVisible={this.state.viewModalVisible}
            handleCancel={this.handleCancel}
            title="view"
          />
        ) : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
